//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//
import { createContext, useContext } from 'react';

/**
 * Lets a tool row download the full output of its call without knowing which chat it is in
 * or how the request is made (spec 007). AIModule provides it for the open conversation;
 * without a provider there is nothing to call, and the Download button stays disabled.
 *
 * `conversationId` is the conversation the row belongs to; when absent the open chat is used.
 *
 * Resolves when the file has been saved. Rejects with an Error whose message is meant to be
 * shown to the user ("This output is no longer available.", ...).
 */
export interface ToolOutputDownload {
  download?: (toolCallId: string, conversationId?: string) => Promise<void>;
}

export const ToolOutputDownloadContext = createContext<ToolOutputDownload>({});

export const useToolOutputDownload = (): ToolOutputDownload =>
  useContext(ToolOutputDownloadContext);
